import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";

function DuaList() {
  const [duaData, setDuaData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const limit = 20;

  useEffect(() => {
    fetch(baseUrl + "api/v1/dua")
      .then((res) => res.json())
      .then((data) => setDuaData(Array.isArray(data) ? data : []))
      .catch(() => setDuaData([]));
  }, []);

  const filteredDuas = duaData.filter((dua) =>
    `${dua.title} ${dua.reciter} ${dua.riwaya}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );

  const displayedDua = filteredDuas.slice(0, page * limit);

  return (
    <>
      <div className="search-input">
        <input
          type="text"
          placeholder="Search dua..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="reciters-grid">
        {displayedDua.map((dua) => (
          <button
            key={dua.id}
            className="reciter-card"
            onClick={() => navigate(`/dua/${dua.slug}`)}
          >
            <img
              src={
                dua.image
                  ? `${baseUrl}storage/${dua.image}`
                  : `${baseUrl}storage/images/dua.png`
              }
              alt={dua.title}
            />
            <div className="dua-info">
              <h3 className="title">{dua.title}</h3>
              <h3 className="reciter">{dua.reciter}</h3>
              <h3 className="riwaya">{dua.riwaya}</h3>
            </div>
          </button>
        ))}
      </div>

      {displayedDua.length < filteredDuas.length && (
        <button className="load-more" onClick={() => setPage(page + 1)}>
          Load More
        </button>
      )}
    </>
  );
}

export default DuaList;
